import { css } from 'styled-components';
import { colors } from '../../atoms/colors/colors';
import { spacing } from '../../atoms/spacing/spacing';
import { CheckboxTags } from './class-name-tags';
export const checkboxLightTheme = {
    base: css `
    & .${CheckboxTags.root} {
      padding: unset;
      min-width: 0.875rem;
      min-height: 0.875rem;
      width: 0.875rem;
      height: 0.875rem;

      border-radius: 3px;
      border: 1px solid ${colors.coolgrey500};
      background-color: ${colors.white};

      &[data-state='checked'] {
        border-color: ${colors.ultramarine800};
      }

      &[disabled] {
        opacity: 0.9;

        &[data-state='checked'] {
          opacity: 0.4;
        }
      }
    }

    & .${CheckboxTags.icon} {
      width: 0.75rem;
      height: 0.75rem;
    }

    & .${CheckboxTags.indicator} {
      background-color: ${colors.ultramarine800};
      color: ${colors.white};
    }

    & .${CheckboxTags.label} {
      color: ${colors.ultramarine900};
      margin-left: ${spacing.spacing8};
    }

    & .${CheckboxTags.labelDisabled} {
      color: ${colors.coolgrey600};
    }
  `,
};
//# sourceMappingURL=light-theme.js.map